const SearchIcon = ({ className, style }: { className?: string; style?: any }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.1665 3.33268C5.94484 3.33268 3.33317 5.94435 3.33317 9.16601C3.33317 12.3877 5.94484 14.9993 9.1665 14.9993C12.3882 14.9993 14.9998 12.3877 14.9998 9.16601C14.9998 5.94435 12.3882 3.33268 9.1665 3.33268ZM1.6665 9.16601C1.6665 5.02388 5.02437 1.66602 9.1665 1.66602C13.3086 1.66602 16.6665 5.02388 16.6665 9.16601C16.6665 13.3082 13.3086 16.666 9.1665 16.666C5.02437 16.666 1.6665 13.3082 1.6665 9.16601Z"
        fill="#D8DBE8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3276 13.3281C13.653 13.0026 14.1806 13.0026 14.5061 13.3281L18.0894 16.9114C18.4149 17.2368 18.4149 17.7645 18.0894 18.0899C17.764 18.4153 17.2363 18.4153 16.9109 18.0899L13.3276 14.5066C13.0021 14.1811 13.0021 13.6535 13.3276 13.3281Z"
        fill="#D8DBE8"
      />
    </svg>
  );
};

export default SearchIcon;
